module.exports = __webpack_public_path__ + "static/media/over50_premium_contract6.c90bdc46.webp";